var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23642 3.82422H2.33166C2.00654 3.82422 1.73047 4.07517 1.73047 4.39916V6.19892C1.73047 6.5229 2.00654 6.77386 2.33166 6.77386C2.65678 6.77386 2.93285 6.5229 2.93285 6.19892V4.9741H4.23642C4.56154 4.9741 4.83761 4.72314 4.83761 4.39916C4.83761 4.07517 4.56154 3.82422 4.23642 3.82422Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6622 11.9229C15.3371 11.9229 15.061 12.1738 15.061 12.4978V13.7226H13.7574C13.4323 13.7226 13.1562 13.9736 13.1562 14.2976C13.1562 14.6215 13.4323 14.8725 13.7574 14.8725H15.6622C15.9873 14.8725 16.2634 14.6215 16.2634 14.2976V12.4978C16.2634 12.1738 15.9873 11.9229 15.6622 11.9229Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6622 3.82422H13.7574C13.4323 3.82422 13.1562 4.07517 13.1562 4.39916C13.1562 4.72314 13.4323 4.9741 13.7574 4.9741H15.061V6.19892C15.061 6.5229 15.3371 6.77386 15.6622 6.77386C15.9873 6.77386 16.2634 6.5229 16.2634 6.19892V4.39916C16.2634 4.07517 15.9873 3.82422 15.6622 3.82422Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23642 13.7231H2.93285V12.4983C2.93285 12.1743 2.65678 11.9233 2.33166 11.9233C2.00654 11.9233 1.73047 12.1743 1.73047 12.4983V14.298C1.73047 14.622 2.00654 14.873 2.33166 14.873H4.23642C4.56154 14.873 4.83761 14.622 4.83761 14.298C4.83761 13.9741 4.56154 13.7231 4.23642 13.7231Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22619 5.62549C3.90107 5.62549 3.625 5.87644 3.625 6.20043V12.4996C3.625 12.8236 3.90107 13.0745 4.22619 13.0745C4.55131 13.0745 4.82738 12.8236 4.82738 12.4996V6.20043C4.82738 5.87644 4.55131 5.62549 4.22619 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14416 5.62549C5.81904 5.62549 5.54297 5.87644 5.54297 6.20043V10.6998C5.54297 11.0238 5.81904 11.2748 6.14416 11.2748C6.46928 11.2748 6.74535 11.0238 6.74535 10.6998V6.20043C6.74535 5.87644 6.46928 5.62549 6.14416 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03869 5.62549C7.71357 5.62549 7.4375 5.87644 7.4375 6.20043V10.6998C7.4375 11.0238 7.71357 11.2748 8.03869 11.2748C8.36381 11.2748 8.63988 11.0238 8.63988 10.6998V6.20043C8.63988 5.87644 8.36381 5.62549 8.03869 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94494 5.62549C9.61982 5.62549 9.34375 5.87644 9.34375 6.20043V12.4996C9.34375 12.8236 9.61982 13.0745 9.94494 13.0745C10.2701 13.0745 10.5461 12.8236 10.5461 12.4996V6.20043C10.5461 5.87644 10.2701 5.62549 9.94494 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8473 5.62549C11.5222 5.62549 11.2461 5.87644 11.2461 6.20043V10.6998C11.2461 11.0238 11.5222 11.2748 11.8473 11.2748C12.1724 11.2748 12.4485 11.0238 12.4485 10.6998V6.20043C12.4485 5.87644 12.1724 5.62549 11.8473 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 5.62549C13.4323 5.62549 13.1562 5.87644 13.1562 6.20043V12.4996C13.1562 12.8236 13.4323 13.0745 13.7574 13.0745C14.0826 13.0745 14.3586 12.8236 14.3586 12.4996V6.20043C14.3586 5.87644 14.0826 5.62549 13.7574 5.62549Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16064 11.9229H6.15112C5.82432 11.9229 5.55469 12.1754 5.55469 12.4978C5.55469 12.8233 5.83718 13.0727 6.16064 13.0727C6.48576 13.0727 6.76183 12.8218 6.76183 12.4978C6.76183 12.1738 6.48576 11.9229 6.16064 11.9229Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05908 11.9229H8.04955C7.72276 11.9229 7.45312 12.1754 7.45312 12.4978C7.45312 12.8233 7.73562 13.0727 8.05908 13.0727C8.3842 13.0727 8.66027 12.8218 8.66027 12.4978C8.66027 12.1738 8.3842 11.9229 8.05908 11.9229Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8677 11.9233H11.8581C11.5313 11.9233 11.2617 12.1759 11.2617 12.4983C11.2617 12.8238 11.5442 13.0732 11.8677 13.0732C12.1928 13.0732 12.4689 12.8223 12.4689 12.4983C12.4689 12.1743 12.1928 11.9233 11.8677 11.9233Z",
    fill: "#121B26",
    stroke: "#121B26",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.4ca833a7a02e8e8c58f7a5e32e127cba.svg";
export { ForwardRef as ReactComponent };